import React, {useEffect} from "react";
import NavXCSI from "../layout/respnsivenavigation/nav-xsci";
import FooterXsci from "../layout/footer/footer-xsci";
import CenteredPageContainer from "../common/centeredcontainer/centered-page-container";
import {useTranslation} from "react-i18next";
import HeroSectionV2 from "../common/herobanner/v2/hero-section-v2";
import Intro from "./intro/intro";
import Services from "./services/services";
import WhyChooseUs from "./why-choose-us/whyChooseUs";
import ParallaxSection from "./parallax-cta/parallax-section";

const pageTitle = "Custom Web Development, Software & Design Solutions in Kanata - XSCI";
const metaDescriptionContent = "XSCI specializes in custom web development, responsive design, and software solutions in Kanata. " +
    "We help businesses grow with scalable, high-performing web apps and modern digital solutions. Get started with a custom project today!";


const HomePage = () => {

    const { t, i18n } = useTranslation(); // Use the translation hook

    const currentLanguage = i18n.language; // Get current language


    useEffect(() => {
        document.title = pageTitle;

        // Set the meta description
        let metaDescription = document.querySelector("meta[name='description']") as HTMLMetaElement;

        // The content you're trying to use for the meta description
        const descriptionContent = metaDescriptionContent;

        if (metaDescription) {
            metaDescription.setAttribute("content", descriptionContent); // Correctly set the content
        } else {
            metaDescription = document.createElement("meta") as HTMLMetaElement;
            metaDescription.name = "description";
            metaDescription.content = descriptionContent;
            document.head.appendChild(metaDescription);
        }
    }, []);


    return (
        <>
            <NavXCSI/>
            {/*<NavbarTest/>*/}
            {/*<HeroBanner*/}
            {/*    animate={true}*/}
            {/*    headLine={String(t('homePage.headLine'))}*/}
            {/*    subHeadLine={String(t('homePage.subHeadLine'))}*/}
            {/*    cta={String(t('homePage.bannerCta'))}*/}
            {/*    bannerImage={img} />*/}
            {/*<HeroBanner*/}
            {/*    backgroundImageUrl={img}*/}
            {/*    title={String(t('homePage.headLine'))}*/}
            {/*    subtitle={String(t('homePage.subHeadLine'))}*/}
            {/*/>*/}
            <HeroSectionV2
                backgroundImage={"/images/home/banner.jpg"}
                title={String(t('homePage.headLine'))}
                highlight=""
                description={String(t('homePage.subHeadLine'))}/>
            {/* Using the new CenteredPageContainer */}
            <CenteredPageContainer component={() => (
                <>
                    <Intro/>
                </>
            )} />
            <Services/>
            <WhyChooseUs/>
            <ParallaxSection
                message={"Ready to discuss your project?"}
                subMessage={"Tell us what you need, we’ll take care of the rest."}
                buttonText={"Let's talk"}
            />
            <FooterXsci/>
        </>
    );
};

export default HomePage;
